import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import useWorkbook from 'components/ScalarSpreadsheet/utilities/useWorkbook';
import { GrossIRRSummaryProps } from './GrossIRRSummary.props';
import { useGrossIRRSpreadsheetConfig } from './hooks/useGrossIRRSpreadsheetConfig';

const GrossIRRSummary: React.FC<GrossIRRSummaryProps> = ({
  fundsGrossIrr,
  firmGrossIrr,
  fundIdToName,
  firmName,
}) => {
  const { spreadsheet, hasData } = useGrossIRRSpreadsheetConfig({
    fundsGrossIrr,
    firmGrossIrr,
    fundIdToName,
    firmName,
  });

  const spreadsheets = useMemo(() => (spreadsheet ? [spreadsheet] : []), [spreadsheet]);
  const { cells, workbook, data } = useWorkbook(spreadsheets);

  if (!hasData || !spreadsheet) {
    return null;
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" sx={{ mb: 1, pl: '12px', color: 'primary.main' }}>
        Gross IRR Summary
      </Typography>
      {cells && data && (
        <ScalarSpreadsheet
          {...spreadsheet}
          cells={cells}
          showTitlesColumn={false}
          showToolbar={false}
          workbook={workbook}
          sheet={spreadsheet}
          data={data}
        />
      )}
    </Box>
  );
};

export default GrossIRRSummary;
